import { HttpRequest, HttpHandlerFn, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

export function allowedHeaderCleanupInterceptor(
  request: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> {
  const allowedHeaders = [
    'organization-id',
    'project-id',
    'project-namespace-id',
    'request-domain',
    'x-frontend-request',
    'x-correlation-id',
    'authorization',
    'x-device',
    'git-credentials',
    'content-type',
    'Content-Type',
    'cache-control',
    'if-modified-since',
    'x-requested-with',
    'user-agent',
    'keep-alive',
    'x-customheader',
    'dnt',
    'x-callback-url',
    'device-version',
    'access-token',
    'refresh-token',
    'cluster-id',
    'correlation-id',
    'device',
    'workspace-name'
  ];

  // Remove all headers not in the allowed list
  for (const key of request.headers.keys()) {
    if (!allowedHeaders.includes(key.toLowerCase())) {
      request = request.clone({
        headers: request.headers.delete(key)
      });
    }
  }

  return next(request);
}
